import React, { useEffect, useRef, useState } from "react";
import "./compra-redirect.css";

import Ripaton from "../../assets/img/home/ripaton-preto 2.png";
import Star from "../../assets/img/home/Vector (1).png";
import { motion, useScroll, useTransform } from "framer-motion";

const CompraRedirect: React.FC = () => {
  const containerRef = useRef(null);

  const { scrollYProgress } = useScroll({
    target: containerRef,
    offset: ["start end", "end start"],
  });

  const x = useTransform(scrollYProgress, [0, 0.5], ["100%", "0%"]);
  const y = useTransform(scrollYProgress, [0, 0.5], ["0%", "100%"]);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth >= 920);
    };

    checkMobile();

    window.addEventListener("resize", checkMobile);

    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  const [isMobile, setIsMobile] = useState(false);

  return (
    <div className="compra-redirect ">
      <div className=" section-hover-click-container">
        <div className="compra-redirect-header">
          {isMobile ? (
            <motion.img
              src={Ripaton}
              alt="figura de um Polígono de fundo"
              className=""
              style={{
                zIndex: "9999",
                x,
                y,
              }}
            />
          ) : (
            <img
              src={Ripaton}
              alt="figura de um Polígono de fundo"
              className=""
              style={{
                zIndex: "9999",
              }}
            />
          )}
        </div>

        <div ref={containerRef} className="compra-redirect-midle-container">
          <div className="compra-redirect-midle-content">
            <h1>
              <img src={Star}></img>
              Criamos
              <img src={Star}></img>
            </h1>
          </div>
          <div className="compra-redirect-midle-content-text">
            <h2>um novo instrumento musical que transforma vidas</h2>
            <p>
              Mais do que criar instrumentos, queremos criar oportunidades,
              ajudando a transformar vidas por meio da música
            </p>
          </div>
        </div>

        <div style={{ width: "1px", height: "1px", marginTop: "100px" }}></div>
      </div>
    </div>
  );
};

export default CompraRedirect;
